export default "__VITE_ASSET__c1e67a26__"